/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FeedSignalPatch = {
    properties: {
        clavaNote: {
            type: 'string',
            isRequired: true,
        },
        resolved: {
            type: 'boolean',
            isRequired: true,
        },
    },
} as const;
